const isNumber = (value: string | number) => {
    try {
        return ((value != null) && (value !== '') && !isNaN(Number(value.toString())));
    } catch(error) {
        return false;
    }
}

export default isNumber;